enum WorkingState  {
    Idle = 0,
    Working,
    Paused,
    Warmup,
}
export default WorkingState